import React from 'react'

import { Typography, TypographyType } from '../typography/Typography'

interface TitleTextProps {
  containerClassName?: string
  titleClassName?: string
  textClassName?: string
  titleType: TypographyType | undefined
  titleTag: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | undefined
  textType: TypographyType | undefined
  textTag: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | undefined
  title: string
  text: string
  children?: React.ReactNode
}

const TitleText = ({
  containerClassName,
  titleClassName,
  textClassName,
  titleType,
  titleTag,
  textType,
  textTag,
  title,
  text,
  children,
}: TitleTextProps) => {
  return (
    <div className={containerClassName}>
      <Typography type={titleType} tag={titleTag} className={titleClassName}>
        {title}
      </Typography>
      <Typography type={textType} tag={textTag} className={textClassName}>
        {text}
      </Typography>
      {children}
    </div>
  )
}

export default TitleText
